import { FC } from 'react'
import Link from 'next/link'
import { ButtonProps as Props, ButtonTypes } from './types'
import { ButtonArrow } from './assets'
import classNames from 'classnames'
import styles from './Button.module.scss'

const Button: FC<Props> = ({
  extraClasses,
  isDisabled,
  isFullWidth,
  isFullWidthMobile,
  isInverse,
  link,
  isNotSubmit,
  onClick,
  type,
  withArrow,
  withGradient,
  children
}) => {
  return (
    <>
      {!link ? (
        <button
          onClick={onClick}
          className={classNames(
            styles.btn,
            styles[`btn-${type || 'primary'}`],
            { 'is-fullwidth': isFullWidth },
            { [styles['is-fullwidth-mobile']]: isFullWidthMobile },
            { [styles['is-inverse']]: isInverse },
            { [styles['with-arrow']]: withArrow },
            { [styles['with-gradient']]: withGradient },
            extraClasses
          )}
          disabled={isDisabled}
          type={isNotSubmit ? 'button' : undefined}
        >
          {children}
          {withArrow && (
            <>
              &nbsp;
              <ButtonArrow className={styles.arrow} />
            </>
          )}
        </button>
      ) : (
        <Link href={link}>
          <a
            className={classNames(
              styles.btn,
              styles[`btn-${type || 'primary'}`],
              { 'is-fullwidth': isFullWidth },
              { [styles['is-fullwidth-mobile']]: isFullWidthMobile },
              { [styles['is-inverse']]: isInverse },
              { [styles['with-arrow']]: withArrow },
              { [styles['with-gradient']]: withGradient },
              extraClasses
            )}
          >
            {children}
            {withArrow && (
              <>
                &nbsp;
                <ButtonArrow className={styles.arrow} />
              </>
            )}
          </a>
        </Link>
      )}
    </>
  )
}

Button.defaultProps = {
  onClick: null,
  extraClasses: null,
  isDisabled: false,
  isFullWidth: false,
  isFullWidthMobile: false,
  isInverse: false,
  link: null,
  isNotSubmit: false,
  type: ButtonTypes.PRIMARY,
  withArrow: false,
  withGradient: true
}

export default Button
